<template>
  <header class="tender-header">
    <bear-traffic-actions v-if="isTraffic"></bear-traffic-actions>
    <bear-actions v-else>
      <template #append>
        <bear-registration></bear-registration>
      </template>
    </bear-actions>
  </header>
</template>
<script>
import { mapState } from 'vuex'
import BearActions from '~@/actions/src'
import BearRegistration from '~@/registration/src'
import BearTrafficActions from '~@/traffic-actions/src'
export default {
  name: 'TenderHeader',
  components: {
    BearActions,
    BearRegistration,
    BearTrafficActions
  },
  computed: {
    ...mapState(['isTraffic'])
  }
}
</script>
<style lang="scss" scoped>
</style>